import { useRouteContext } from '@tanstack/react-router';

export function useAccommodationRepository() {
  const repository = useRouteContext({
    strict: false,
    select: (context) => context.accommodationRepository,
  });

  if (!repository) throw new Error('AccommodationRepository must be provided in context');

  return repository;
}
